// Default zoom level to display layer (deck.gl value is 1 lower than google maps)
export const CONSTRAINTS_MIN_ZOOM = 10;
export const CONSTRAINTS_LAYER_STROKE_THRESHOLD = 14;
export const CONSTRAINTS_LAYER_TYPE_ID = "CONSTRAINTS_LAYER_TYPE_ID";
export const LISTED_BUILDINGS_LAYER_SUMMARY_TYPE_ID = "LISTED_BUILDINGS_LAYER_SUMMARY_TYPE_ID";
export const DISPLAY_BY_CATEGORY = "DISPLAY_BY_CATEGORY";
